import { ErrorOutlineRounded } from '@mui/icons-material'
import { Box, Paper, Stack, Typography } from '@mui/material'
import { FunctionComponent } from 'react'

export const ClosedReportPeriodMessage: FunctionComponent<{openDialog: () => void}> = ({ openDialog}) => {
  return (
      <Paper variant='outlined' sx={{ backgroundColor: 'lightGrey.light', height: '150px', width: '100%', mb: 2 }}>
        <Stack display='flex' flexDirection='column' gap={2} justifyContent='center' alignItems='center' sx={{ height: '100%' }}>
          <Stack display='flex' flexDirection='row' gap={2} justifyContent='center' alignItems='center' >
            <ErrorOutlineRounded sx={{ fontSize: '1.5rem', color: 'text.secondary' }} />
            <Typography sx={{ fontSize: '1rem', color: 'text.secondary' }}>You do not have an open Report Period</Typography>
          </Stack>
          <Box onClick={() => openDialog()}><Typography sx={{ color: 'primary.main', textDecoration: 'underline', cursor: 'pointer' }}>Click here to start one</Typography></Box>
        </Stack>
      </Paper>
  )
} 